import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";

import SongsAddAlbum from "@/features/songs/album/SongsAddAlbum";
import SideNavLayout from "@/layouts/SideNavLayout";
import { SongsMenu } from "@/layouts/SubSideNavMenus";

function CreateAlbumPage() {
  const flags = useFlags();
  const navigate = useNavigate();

  const addAlbumEnabled = flags["pd-add-album-feature"] === true;

  useEffect(() => {
    if (!addAlbumEnabled) {
      void navigate({ to: "/songs", replace: true });
    }
  }, [addAlbumEnabled, navigate]);

  if (!addAlbumEnabled) {
    return null;
  }

  return (
    <SideNavLayout menu={<SongsMenu />}>
      <SongsAddAlbum key="create-album" />
    </SideNavLayout>
  );
}

export const Route = createFileRoute("/_auth/songs/create-album")({
  component: CreateAlbumPage,
});
